import React, { Component } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import {
  fetchProduct,
  editProduct,
  deleteProduct,
} from "../../../actions/masters/productActions";
import ProductForm from "./ProductForm";
import { Link } from "react-router-dom";
import Spinner from "../../Spinner";
import history from "../../../history";

class ProductEdit extends Component {
  componentDidMount() {
    this.props.fetchProduct(this.props.match.params.id);
  }

  onSubmit = (formValues) => {
    this.props.editProduct(this.props.match.params.id, formValues);
  };

  onClickDelete = () => {
    this.props.deleteProduct(this.props.match.params.id, this.props.product);
  };

  render() {
    return (
      <div>
        {this.props.product === undefined ? (
          <Spinner />
        ) : (
          <div className="BodyInContainer">
            <div className="d-block clearfix">
              <div className="Header-Content float-start">
                <h3 className="pageMainTitle">Edit Product</h3>
              </div>
              <div className="float-end mt-15">
                <Link
                  className="float-end cardBackBtn"
                  onClick={() => {
                    history.goBack();
                  }}
                >
                  Back
                </Link>
              </div>
            </div>
            <ProductForm
              initialValues={_.pick(this.props.product, "name", "activeFlag")}
              onSubmit={this.onSubmit}
              onDelete={this.onClickDelete}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return { product: state.product[ownProps.match.params.id] };
};

export default connect(mapStateToProps, {
  editProduct,
  fetchProduct,
  deleteProduct,
})(ProductEdit);
